class PdpKeyIngredients extends HTMLElement {
  connectedCallback() {
    if (this._ready) return
    this._ready = true

    this.desktopMq = window.matchMedia('(min-width: 1051px)')
    this.items = this.querySelector('[data-ki-items]')
    this.stickyItems = [...this.querySelectorAll('[data-ki-sticky-item]')]
    this.headers = [...this.querySelectorAll('[data-accordion-header]')]

    this.onDesktopChange = () => this.bindDesktop()
    this.desktopMq.addEventListener('change', this.onDesktopChange)
    this.bindDesktop()
  }

  disconnectedCallback() {
    this.desktopMq?.removeEventListener('change', this.onDesktopChange)
    this.unbindDesktop()
  }

  bindDesktop() {
    this.unbindDesktop()

    if (!this.desktopMq.matches) return

    this.headers.forEach((header) => {
      header.addEventListener('mouseenter', this.onHeaderEnter)
    })

    this.items?.addEventListener('mouseleave', this.onItemsLeave)
    this.show(0)
  }

  unbindDesktop() {
    this.headers.forEach((header) => {
      header.removeEventListener('mouseenter', this.onHeaderEnter)
    })

    this.items?.removeEventListener('mouseleave', this.onItemsLeave)
  }

  onHeaderEnter = (event) => {
    const index = Number(event.currentTarget.dataset.kiIndex)
    if (Number.isNaN(index)) return
    this.show(index)
  }

  onItemsLeave = () => {
    this.clear()
  }

  show(index) {
    this.stickyItems.forEach((item) => {
      const active = Number(item.dataset.kiIndex) === index
      item.classList.toggle('is-active', active)
    })
  }

  clear() {
    this.stickyItems.forEach((item) => {
      item.classList.remove('is-active')
    })
  }
}

customElements.define('pdp-key-ingredients', PdpKeyIngredients)
